export const PathDoc = {
  // ADMINISTRADOR

  // ADMIN CLIENTES
  AdminClientCreate: 'https://dockeapstaff.web.app/docs/admin/como-criar-um-evento/',

  // ADMIN COLAB
  AdminCollabCreate: 'https://dockeapstaff.web.app/docs/admin/colaboradores/',
  AdminCollabEdit: 'https://dockeapstaff.web.app/docs/admin/colaboradores/#como-editar-um-colaborador',
  AdminCollabValidate: 'https://dockeapstaff.web.app/docs/admin/colaboradores/#como-validar-um-colaborar',

  // ADMIN CONFIG
  // HOME
  AdminHome: 'https://dockeapstaff.web.app/docs/admin/configuracoes/',
  // User
  UserCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#usu%C3%A1rios',
  UserEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-editar-um-usu%C3%A1rio',

  // Setores
  SectorCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#setores',
  SectorEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-editar-um-setor',

  // Planos
  PlansCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#planos',
  PlansEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-editar-um-plano',

  // Documentos
  DocumentsCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#documentos',
  DocumentsEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-editar-um-documento',

  // Consetimentos
  ConsentsCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#consentimentos',
  ConsentsEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-adicionar-um-consentimento',

  // Cargos
  PositionCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#cargos',
  PositionEdit: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#como-editar-um-cargo',

  // Relatórios
  ReportCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#resumo',

  // Avisos
  Notices: 'https://dockeapstaff.web.app/docs/admin/configuracoes#avisos',

  // Reasos
  ReasonsCreate: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#motivos',

  // LogSystem
  Logsystem: 'https://dockeapstaff.web.app/docs/admin/configuracoes/#logs-do-sistema',

  // AREA DO CLIENTE
  ClientIntro: 'https://dockeapstaff.web.app/docs/intro',
  ClientHome: 'https://dockeapstaff.web.app/docs/client/Primeiros_passos',

  // Eventos
  Events: 'https://dockeapstaff.web.app/docs/client/Eventos#primeiros-passos',
  CreateEvents: 'https://dockeapstaff.web.app/docs/client/Eventos#tela-de-cadastro-de-novo-evento',
  EventPosition: 'https://dockeapstaff.web.app/docs/client/Eventos/#vagas-do-evento',
  EventCreatePosition: 'https://dockeapstaff.web.app/docs/client/Eventos/#-adicionar-vagas',
  EventStaff: 'https://dockeapstaff.web.app/docs/client/Eventos/#-staff-do-evento',
  EventHistory: 'https://dockeapstaff.web.app/docs/client/Eventos#-hist%C3%B3rico-de-a%C3%A7%C3%B5es',
  EventAddCollab: 'https://dockeapstaff.web.app/docs/client/Eventos/#-convidar-um-staff-favoritado',
  EventCollabHours: 'https://dockeapstaff.web.app/docs/client/Eventos/#-adicionar-marca%C3%A7%C3%A3o-de-ponto',
  EventImportPayments: 'https://dockeapstaff.web.app/docs/client/Eventos/#-importar-pagamentos',
  EventFinally: 'https://dockeapstaff.web.app/docs/client/Eventos/#-finalizando-o-evento-no-sistema',

  // Colaboradores
  Favorites: 'https://dockeapstaff.web.app/docs/client/Colaboradores#favoritados',
  Blockeds: 'https://dockeapstaff.web.app/docs/client/Colaboradores#bloqueados',

  // Config
  // Pagamentos
  ClientPayments: 'https://dockeapstaff.web.app/docs/client/Configuracoes#painel-de-pagamentos',
  ClientUsers: 'https://dockeapstaff.web.app/docs/client/Configuracoes#tela-de-gerenciamento-de-usu%C3%A1rios',
  ClientSectors: 'https://dockeapstaff.web.app/docs/client/Configuracoes#-tela-de-gerenciamento-de-setores',
  ClientEditSectors: 'https://dockeapstaff.web.app/docs/client/Configuracoes#como-editar-um-setor',
}
